import React from 'react';
import { useSelector } from 'react-redux';
import classNames from 'classnames';
import { CoreLink } from '@uncinc/react-drupal-core';

import { DEFAULT_LANGUAGE } from '../../config/constants';
import Container from '../Container';

import './style.scss';

const Breadcrumbs = (props) => {
  const { includeCurrent, noBorders } = props;

  const breadcrumbs = useSelector((state) => state.getIn(['entity', 'breadcrumbs']));
  const { currentTitle, currentUrl } = useSelector((state) => {
    const entityId = state.getIn(['entity', 'entityId']);
    const entityType = state.getIn(['entity', 'entityType']);
    const entity = entityType === 'taxonomy_term' ? state.getIn(['taxonomyTerm', entityId]) : state.getIn([entityType, entityId]);
    if (!entity) {
      return { currentTitle: null, currentUrl: null };
    }
    const title = entityType === 'taxonomy_term' ? entity.getIn(['name', 0, 'value']) : entity.getIn(['title', 0, 'value']);
    const url = entity.getIn(['paths', DEFAULT_LANGUAGE]);
    return { currentTitle: title, currentUrl: url };
  });

  let breadcrumbItems = breadcrumbs.map((item, index) => {
    const url = item.get('url');
    const title = item.get('title');
    const breadcrumbItemClassnames = classNames('Breadcrumbs__item', {
      'icon-before': index === 0,
      'icon-home': index === 0,
      'icon-variant-black': index === 0,
    });
    return (
      <li key={url} className={breadcrumbItemClassnames} itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
        <CoreLink property="item" typeof="WebPage" to={url}>{title}</CoreLink>
        <meta property="position" content={index} />
      </li>
    );
  });

  if (breadcrumbItems.size < 2) return null;

  if (includeCurrent && currentTitle && currentUrl) {
    const index = breadcrumbItems.size + 1;
    breadcrumbItems = breadcrumbItems.push(
      <li key={currentUrl} className="Breadcrumbs__item" itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
        <CoreLink property="item" typeof="WebPage" to={currentUrl}>{currentTitle}</CoreLink>
        <meta property="position" content={index} />
      </li>,
    );
  }

  const wrapperClasses = classNames('Breadcrumbs__wrapper', {
    'Breadcrumbs__wrapper--no-borders': noBorders,
  });

  return (
    <div className={wrapperClasses}>
      <Container>
        <ol className="Breadcrumbs" itemScope itemType="https://schema.org/BreadcrumbList">
          {breadcrumbItems}
        </ol>
      </Container>
    </div>
  );
};

export default Breadcrumbs;
